// English translations for React Admin (using default messages from react-admin)

const englishMessages = {
    ra: {
        action: {
            add_filter: 'Add filter',
            add: 'Add',
            back: 'Go Back',
            bulk_actions: '%{smart_count} selected',
            cancel: 'Cancel',
            clear_array_input: 'Clear the list',
            clear_input_value: 'Clear value',
            clone: 'Clone',
            confirm: 'Confirm',
            create: 'Create',
            create_item: 'Create %{item}',
            delete: 'Delete',
            edit: 'Edit',
            export: 'Export',
            list: 'List',
            refresh: 'Refresh',
            remove_filter: 'Remove this filter',
            remove_all_filters: 'Remove all filters',
            remove: 'Remove',
            save: 'Save',
            search: 'Search',
            select_all: 'Select all',
            select_row: 'Select this row',
            show: 'Show',
            sort: 'Sort',
            undo: 'Undo',
            unselect: 'Unselect',
            expand: 'Expand',
            close: 'Close',
            open_menu: 'Open menu',
            close_menu: 'Close menu',
            update: 'Update',
            move_up: 'Move up',
            move_down: 'Move down',
            open: 'Open',
            toggle_theme: 'Toggle Theme',
            select_columns: 'Columns',
            reset: 'Reset',
            search_columns: 'Search columns',
            select_all_button: 'Select all',
            update_application: 'Reload Application',
        },
        boolean: {
            true: 'Yes',
            false: 'No',
            null: ' ',
        },
        page: {
            create: 'Create %{name}',
            dashboard: 'Dashboard',
            edit: '%{name} #%{id}',
            error: 'Something went wrong',
            list: '%{name}',
            loading: 'Loading',
            not_found: 'Not Found',
            show: '%{name} #%{id}',
            empty: 'No %{name} yet.',
            invite: 'Do you want to add one?',
        },
        input: {
            file: {
                upload_several: 'Drop some files to upload, or click to select one.',
                upload_single: 'Drop a file to upload, or click to select it.',
            },
            image: {
                upload_several: 'Drop some pictures to upload, or click to select one.',
                upload_single: 'Drop a picture to upload, or click to select it.',
            },
            references: {
                all_missing: 'Unable to find references data.',
                many_missing: 'At least one of the associated references no longer appears to be available.',
                single_missing: 'Associated reference no longer appears to be available.',
            },
            password: {
                toggle_visible: 'Hide password',
                toggle_hidden: 'Show password',
            },
        },
        message: {
            about: 'About',
            are_you_sure: 'Are you sure?',
            bulk_delete_content: 'Are you sure you want to delete this %{name}? |||| Are you sure you want to delete these %{smart_count} items?',
            bulk_delete_title: 'Delete %{name} |||| Delete %{smart_count} %{name}',
            bulk_update_content: 'Are you sure you want to update this %{name}? |||| Are you sure you want to update these %{smart_count} items?',
            bulk_update_title: 'Update %{name} |||| Update %{smart_count} %{name}',
            delete_content: 'Are you sure you want to delete this item?',
            delete_title: 'Delete %{name} #%{id}',
            details: 'Details',
            error: 'A client error occurred and your request could not be completed.',
            invalid_form: 'The form is not valid. Please check for errors',
            loading: 'The page is loading, just a moment please',
            no: 'No',
            not_found: 'Either you typed a wrong URL, or you followed a bad link.',
            yes: 'Yes',
            unsaved_changes: "Some of your changes weren't saved. Are you sure you want to ignore them?",
        },
        navigation: {
            no_results: 'No results found',
            no_more_results: 'The page number %{page} is out of boundaries. Try the previous page.',
            page_out_of_boundaries: 'Page number %{page} out of boundaries',
            page_out_from_end: 'Cannot go after last page',
            page_out_from_begin: 'Cannot go before page 1',
            page_range_info: '%{offsetBegin}-%{offsetEnd} of %{total}',
            partial_page_range_info: '%{offsetBegin}-%{offsetEnd} of more than %{offsetEnd}',
            current_page: 'Page %{page}',
            page: 'Go to page %{page}',
            first: 'Go to first page',
            last: 'Go to last page',
            next: 'Next',
            previous: 'Previous',
            page_rows_per_page: 'Rows per page:',
            skip_nav: 'Skip to content',
        },
        sort: {
            sort_by: 'Sort by %{field} %{order}',
            ASC: 'ascending',
            DESC: 'descending',
        },
        auth: {
            auth_check_error: 'Please login to continue',
            user_menu: 'Profile',
            username: 'Username',
            password: 'Password',
            sign_in: 'Sign in',
            sign_in_error: 'Authentication failed, please retry',
            logout: 'Logout',
        },
        notification: {
            updated: 'Element updated |||| %{smart_count} elements updated',
            created: 'Element created',
            deleted: 'Element deleted |||| %{smart_count} elements deleted',
            bad_item: 'Incorrect element',
            item_doesnt_exist: 'Element does not exist',
            http_error: 'Server communication error',
            data_provider_error: 'dataProvider error. Check the console for details.',
            i18n_error: 'Cannot load the translations for the specified language',
            canceled: 'Action cancelled',
            logged_out: 'Your session has ended, please reconnect.',
        },
        validation: {
            required: 'Required',
            minLength: 'Must be %{min} characters at least',
            maxLength: 'Must be %{max} characters or less',
            minValue: 'Must be at least %{min}',
            maxValue: 'Must be %{max} or less',
            number: 'Must be a number',
            email: 'Must be a valid email',
            oneOf: 'Must be one of: %{options}',
            regex: 'Must match a specific format (regexp): %{pattern}',
        },
        saved_queries: {
            label: 'Saved queries',
            query_name: 'Query name',
            new_label: 'Save current query...',
            new_dialog_title: 'Save current query as',
            remove_label: 'Remove saved query',
            remove_label_with_name: 'Remove query "%{name}"',
            remove_dialog_title: 'Remove saved query?',
            remove_message: 'Are you sure you want to remove that item from your list of saved queries?',
            help: 'Filter the list and save this query for later',
        },
        configurable: {
            customize: 'Customize',
            configureMode: 'Configure this page',
            inspector: {
                title: 'Inspector',
                content: 'Hover the application UI elements to configure them',
                reset: 'Reset Settings',
                hideAll: 'Hide All',
                showAll: 'Show All',
            },
            Datagrid: {
                title: 'Datagrid',
                unlabeled: 'Unlabeled column #%{column}',
            },
            SimpleForm: {
                title: 'Form',
                unlabeled: 'Unlabeled input #%{input}',
            },
            SimpleList: {
                title: 'List',
                primaryText: 'Primary text',
                secondaryText: 'Secondary text',
                tertiaryText: 'Tertiary text',
            },
        },
    },
};

export const en = {
    ...englishMessages,
    resources: {
        companies: {
            name: 'Company |||| Companies',
            fields: {
                name: 'Name',
                email: 'Email',
                phone: 'Phone',
                street: 'Street',
                zip: 'ZIP Code',
                city: 'City',
                country: 'Country',
                billingStreet: 'Billing Street',
                billingZip: 'Billing ZIP Code',
                billingCity: 'Billing City',
                billingCountry: 'Billing Country',
                taxId: 'Tax ID / VAT Number',
                commercialRegister: 'Commercial Register Number',
                website: 'Website',
                active: 'Active',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
            },
            tabs: {
                general: 'General',
                address: 'Address',
                billing: 'Billing Address',
                legal: 'Legal Information',
            },
        },
        users: {
            name: 'User |||| Users',
            fields: {
                email: 'Email',
                firstName: 'First Name',
                lastName: 'Last Name',
                phone: 'Phone',
                mobile: 'Mobile',
                street: 'Street',
                zip: 'ZIP Code',
                city: 'City',
                country: 'Country',
                dateOfBirth: 'Date of Birth',
                jobTitle: 'Job Title',
                department: 'Department',
                language: 'Preferred Language',
                company: 'Company',
                roles: 'Roles',
                userRoles: 'Roles',
                password: 'Password',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
            },
            tabs: {
                general: 'General',
                contact: 'Contact & Address',
                work: 'Work Information',
                personal: 'Personal',
                roles: 'Roles & Permissions',
            },
        },
        invitations: {
            name: 'Invitation |||| Invitations',
            fields: {
                email: 'Email',
                company: 'Company',
                roles: 'Roles',
                token: 'Token',
                createdAt: 'Created at',
                expiresAt: 'Expires at',
                used: 'Used',
                usedAt: 'Used at',
                invitedBy: 'Invited by',
                registeredUser: 'Registered User',
            },
        },
        roles: {
            name: 'Role |||| Roles',
            fields: {
                name: 'Name',
                description: 'Description',
                permissions: 'Permissions',
            },
        },
        permissions: {
            name: 'Permission |||| Permissions',
            fields: {
                name: 'Name',
                description: 'Description',
            },
        },
        products: {
            name: 'Product |||| Products',
            fields: {
                name: 'Name',
                description: 'Description',
                price: 'Price',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
            },
        },
        licenses: {
            name: 'License |||| Licenses',
            fields: {
                company: 'Company',
                product: 'Product',
                validFrom: 'Valid from',
                validUntil: 'Valid until',
                maxUsers: 'Max. Users',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
            },
        },
    },
    custom: {
        changePassword: 'Change Password',
        currentPassword: 'Current Password',
        newPassword: 'New Password',
        confirmPassword: 'Confirm Password',
        passwordChanged: 'Password changed successfully',
        language: 'Language',
        profile: {
            menuItem: 'My Profile',
            emailLocked: 'Email addresses can only be changed by superadmins. Please contact support.',
            title: 'My Profile',
            notLoggedIn: 'You are not logged in',
        },
    },
    profile: {
        avatar: {
            title: 'Profile Picture',
            hint: 'JPG, PNG, GIF or WebP. Max. 2 MB.',
            remove: 'Remove picture',
            uploadSuccess: 'Profile picture uploaded successfully',
            uploadError: 'Error uploading profile picture',
            deleteSuccess: 'Profile picture removed',
            deleteError: 'Error removing profile picture',
            invalidType: 'Invalid file format. Allowed: JPG, PNG, GIF, WebP',
            tooLarge: 'File too large. Maximum 2 MB.',
        },
    },
    courseEnrollmentDialog: {
        title: 'Participants',
        addUser: 'Enroll User',
        bulkEnroll: 'Bulk Enrollment',
        selectUser: 'Select User',
        enroll: 'Enroll',
        remove: 'Remove',
        enrollSuccess: 'User successfully enrolled',
        enrollError: 'Error enrolling user',
        alreadyEnrolled: 'This user is already enrolled',
        removeSuccess: 'Participant successfully removed',
        removeError: 'Error removing participant',
        confirmRemove: 'Do you really want to remove this participant?',
        loadError: 'Error loading participants',
        noEnrollments: 'No participants enrolled yet',
        table: {
            name: 'Name',
            email: 'Email',
            status: 'Status',
            progress: 'Progress',
            enrolledAt: 'Enrolled on',
        },
        status: {
            enrolled: 'Enrolled',
            in_progress: 'In Progress',
            completed: 'Completed',
            failed: 'Failed',
            pending_approval: 'Pending',
            rejected: 'Rejected',
        },
    },
    enrollments: {
        manage: {
            title: 'Manage Enrollments',
            importCsv: 'Import CSV',
            exportCsv: 'Export CSV',
            enrollUser: 'Enroll User',
            bulkEnroll: 'Bulk enrollment',
            bulkPartial: '%{enrolled} enrolled, %{skipped} skipped, %{failed} not enrolled: %{reason}',
            bulkCourse: 'Course',
            deleteConfirm: 'Delete the enrollment of %{user} in "%{course}"? The learning progress in this course will be lost. This cannot be undone.',
            selectCourse: 'Select Course',
            allCourses: 'All Courses',
            statusFilter: 'Status Filter',
            statusAll: 'All',
            statusEnrolled: 'Enrolled',
            statusInProgress: 'In Progress',
            statusCompleted: 'Completed',
            statusFailed: 'Failed',
            loading: 'Loading enrollments...',
            noEnrollments: 'No enrollments found for this course.',
            table: {
                name: 'Name',
                email: 'Email',
                course: 'Course',
                status: 'Status',
                progress: 'Progress',
                score: 'Score',
                enrolled: 'Enrolled',
                started: 'Started',
                completed: 'Completed',
                time: 'Time',
                actions: 'Actions',
            },
            dialog: {
                title: 'Enroll User',
                user: 'User',
                userHelp: 'Select a user from the SSO system',
                course: 'Course',
                enroll: 'Enroll',
            },
        },
        dashboard: {
            title: 'Enrollment Dashboard',
            enrollUser: 'Enroll User',
            stats: {
                total: 'Total Enrollments',
                active: 'Active Learners',
                completed: 'Completed',
                avgProgress: 'Avg. Progress',
            },
            courseStats: {
                title: 'Course Statistics',
                noData: 'No course data available.',
                table: {
                    course: 'Course',
                    enrollments: 'Enrollments',
                    completionRate: 'Completion Rate',
                    avgProgress: 'Avg. Progress',
                    avgScore: 'Avg. Score',
                },
            },
        },
        csvImport: {
            title: 'CSV Import - Enroll Users',
            formatInfo: 'CSV Format: One email address per line. First line will be skipped as header.',
            course: 'Course',
            selectFile: 'Select CSV File',
            file: 'File',
            import: 'Import',
            selectFileAndCourse: 'Please select a CSV file and a course',
            userNotFound: 'User not found',
            enrollError: 'Error enrolling',
            importComplete: 'Import completed: %{success} successful, %{failed} failed',
            processingError: 'Error processing CSV file',
            results: {
                success: 'Successful',
                failed: 'Failed',
                errors: 'Errors',
            },
        },
    },
    menu: {
        dashboard: 'Dashboard',
        mediaLibrary: 'Media Library',
        wiki: 'News & Knowledge',
        courses: 'Courses',
        courseCatalogs: 'Course Catalogs',
        courseCatalog: 'Course Catalog',
        learningPaths: 'Learning Paths',
        achievements: 'My Achievements',
        enrollmentDashboard: 'Enrollment Dashboard',
        manageEnrollments: 'Manage Enrollments',
        enrollments: 'Enrollments',
        myCourses: 'My Courses',
        myCertificates: 'My Certificates',
        bookmarks: 'My Bookmarks',
        analytics: 'Statistics',
        library: 'Library',
        instructorAnalytics: 'Instructor Dashboard',
        learningGroups: 'Learning Groups',
        peerReview: 'Peer Reviews',
        notes: 'My Notes',
        certificates: 'Certificates',
    },
    dashboard: {
        title: 'Dashboard',
        defaultName: 'Learner',
        welcome: 'Welcome back, %{firstName}!',
        subtitle: 'Your Learning and Knowledge Portal',
        quickAccess: 'Quick Access',
        pendingReviews: 'Pending Reviews',
        myLearningGroups: 'My Learning Groups',
        stats: {
            myCourses: 'My Courses',
            inProgress: 'In Progress',
            completed: 'Completed',
            wikiArticles: 'Wiki Articles',
            media: 'Media',
        },
        quickAccessCards: {
            myCourses: {
                title: 'My Courses',
                description: 'Continue your learning',
            },
            catalogs: {
                title: 'Course Management',
                description: 'Create and edit catalogs + courses',
            },
            catalog: {
                title: 'Course Catalog',
                description: 'Discover and enroll in new courses',
            },
            wiki: {
                title: 'Wiki',
                description: 'Browse news & knowledge',
            },
            media: {
                title: 'Media Library',
                description: 'Manage files',
            },
        },
        activities: {
            mostViewed: '📈 Most Viewed Articles',
            recentArticles: '🆕 Recent Articles',
            recentFiles: '📁 Recent Files',
            noArticles: 'No articles available',
            noNewArticles: 'No new articles',
            noFiles: 'No files available',
            views: 'views',
            published: 'Published',
            draft: 'Draft',
        },
    },
    myCourses: {
        title: 'My Courses',
        loading: 'Loading courses...',
        courseNotFound: 'Course not found',
        enrolled: 'Enrolled',
        learningTime: 'Learning time',
        completed: 'Completed',
        noEnrollments: 'You are currently not enrolled in any courses. Please contact your administrator to enroll in courses.',
        noCoursesInProgress: 'No courses in progress.',
        allCoursesStarted: 'All courses have already been started.',
        noCoursesCompleted: 'No courses completed yet.',
        status: {
            completed: 'Completed',
            inProgress: 'In Progress',
            failed: 'Failed',
            notStarted: 'Not started yet',
            pendingApproval: 'Pending',
            rejected: 'Rejected',
            suspended: 'Suspended',
        },
        buttons: {
            start: 'Start Course',
            continue: 'Continue',
            review: 'Review again',
            retry: 'Try again',
        },
        tabs: {
            all: 'All (%{count})',
            inProgress: 'In Progress (%{count})',
            notStarted: 'Not Started (%{count})',
            completed: 'Completed (%{count})',
        },
    },
    certificates: {
        title: 'My Certificates',
        loading: 'Loading certificates...',
        noCertificates: 'No certificates available.',
        search: 'Search certificates...',
        download: 'Download',
        shareTooltip: 'Copy verification link',
        linkCopied: 'Link copied to clipboard',
        copyFailed: 'Copy failed',
        issuedAt: 'Issued on',
        expiresAt: 'Valid until',
        score: 'Score',
        verificationCode: 'Verification Code',
        status: {
            valid: 'Valid',
            expired: 'Expired',
            expiringSoon: 'Expires in %{days} days',
        },
        tabs: {
            all: 'All (%{count})',
            valid: 'Valid (%{count})',
            expired: 'Expired (%{count})',
        },
    },
    layout: {
        language: 'Language',
        profile: 'Profile',
        changePassword: 'Change Password',
        help: 'Help',
        logout: 'Logout',
        loadingTranslations: 'Loading translations...',
    },
    bottomNav: {
        catalogs: 'Catalogs',
        media: 'Media',
        learningPaths: 'Paths',
        achievements: 'Achievements',
    },
    wiki: {
        title: 'News & Knowledge',
        newArticle: 'New Article',
        searchPlaceholder: 'Search articles (title and summary)...',
        categoriesButton: 'Categories',
        categoryLabel: 'Category',
        allCategories: 'All Categories',
        noArticles: 'No articles found',
        loading: 'Loading...',
        edit: 'Edit',
        delete: 'Delete',
        view: 'View',
        confirmDelete: 'Do you really want to delete the article "%{title}"?',
        deleted: 'Article deleted',
        deleteError: 'Error deleting',
        loadError: 'Error loading articles',
        company: 'Company',
        platform: 'FAQ',
        updated: 'Updated',
        editor: {
            newArticle: 'New Article',
            editArticle: 'Edit Article',
            back: 'Back',
            save: 'Save',
            saving: 'Saving...',
            saveAndPublish: 'Save & Publish',
            title: 'Title',
            slug: 'URL Slug',
            slugHelp: 'URL-friendly name (auto-generated)',
            summary: 'Summary',
            summaryHelp: 'Short description for article overview',
            status: 'Status',
            category: 'Category',
            none: 'None',
            visibility: 'Visibility',
            visibilityCompany: 'Company (visible to company users only)',
            visibilityGlobal: 'Global (visible to all companies)',
            content: 'Content',
            version: 'Version',
            versionHistory: 'Version History',
        },
        status: {
            draft: 'Draft',
            published: 'Published',
            archived: 'Archived',
        },
        tabs: {
            all: 'All',
            drafts: 'Drafts',
            published: 'Published',
            archived: 'Archived',
        },
        favorites: 'Favorites',
        noFavorites: 'No favorites yet',
        noFavoritesHint: 'Mark articles as favorites to quickly find them here.',
        categories: {
            title: 'Wiki Categories',
            back: 'Back',
            newCategory: 'New Category',
            editCategory: 'Edit Category',
            noCategories: 'No categories available',
            loadError: 'Error loading categories',
            saveError: 'Error saving',
            deleteError: 'Error deleting',
            updateSuccess: 'Category updated',
            createSuccess: 'Category created',
            deleteSuccess: 'Category deleted',
            nameRequired: 'Please enter a name',
            confirmDelete: 'Do you really want to delete the category "%{name}"?',
            companyCategory: 'Company Category',
            globalCategory: 'Global Category',
            table: {
                name: 'Name',
                color: 'Color',
                icon: 'Icon',
                description: 'Description',
                type: 'Type',
                actions: 'Actions',
            },
            form: {
                name: 'Name',
                color: 'Color',
                icon: 'Icon (Optional)',
                noIcon: 'No Icon',
                description: 'Description',
                globalCategory: 'Global Category (visible to all companies)',
            },
            isPublic: 'Public (FAQ)',
            isPublicHelp: 'Public categories are accessible without login at /faq',
        },
    },
    courses: {
        title: 'Courses',
        catalog: 'Catalog',
        backToCatalogs: 'Back to Catalogs',
        coursesIn: 'Courses in: %{name}',
        newCourse: 'New Course',
        editCourse: 'Edit Course',
        createFirst: 'Create First Course',
        manageLessons: 'Manage Lessons',
        fromLibrary: 'From Library',
        noCourses: 'No courses available yet',
        loading: 'Loading courses...',
        loadError: 'Error loading catalog',
        loadCoursesError: 'Error loading courses',
        saveError: 'Error saving course',
        deleteError: 'Error archiving course',
        updateSuccess: 'Course successfully updated',
        createSuccess: 'Course successfully created',
        deleteSuccess: 'Course successfully archived',
        confirmDelete: 'Do you really want to archive this course?\n\nThe course will become invisible and inaccessible for all participants. Existing certificates will be preserved. Statistics will not be affected.',
        sequential: 'Sequential',
        duration: '%{minutes} min.',
        lessonsCount: '%{count} lessons',
        difficulty: {
            beginner: 'Beginner',
            intermediate: 'Intermediate',
            advanced: 'Advanced',
        },
        form: {
            title: 'Title',
            slug: 'Slug',
            slugHelp: 'URL-friendly identifier (e.g. introduction-javascript)',
            description: 'Description',
            estimatedDuration: 'Estimated Duration (minutes)',
            difficulty: 'Difficulty',
            requireSequentialCompletion: 'Require Sequential Completion',
            active: 'Active',
            tags: 'Tags',
            tagsHelp: 'Comma-separated list (e.g. react, javascript, frontend)',
            certificateType: 'Certificate for course completion',
            certificateTypeParticipated: 'Certificate: participated in the course',
            certificateTypePassed: 'Certificate: passed the course',
            certificateTypeNone: 'Do not issue a certificate',
            certificateTypeRequired: 'Please choose which certificate the course issues.',
            certificateTypePassedWithoutThreshold: 'No lesson has a minimum score – every completion counts as passed. You set the minimum score per lesson.',
            aiTutorEnabled: 'Enable AI Learning Assistant',
            requireTeacherReviewForGrading: 'AI grades require approval by an authorised person (certificate-relevant courses)',
        },
    },
    catalogs: {
        title: 'Course Catalogs',
        loading: 'Loading catalogs...',
        loadError: 'Error loading catalogs',
        newCatalog: 'New Catalog',
        editCatalog: 'Edit Catalog',
        manageCourses: 'Manage Courses',
        active: 'Active',
        inactive: 'Inactive',
        coursesCount: '%{count} courses',
        created: 'Created',
        confirmDelete: 'Do you really want to delete this catalog?',
        updateSuccess: 'Catalog successfully updated',
        createSuccess: 'Catalog successfully created',
        deleteSuccess: 'Catalog successfully deleted',
        saveError: 'Error saving catalog',
        deleteError: 'Error deleting catalog',
        form: {
            name: 'Name',
            description: 'Description',
            active: 'Active',
        },
    },
    lessons: {
        title: 'Lessons',
        loading: 'Loading lessons...',
        loadError: 'Error loading lessons',
        loadCourseError: 'Error loading course',
        newLesson: 'New Lesson',
        editLesson: 'Edit Lesson',
        createFirst: 'Create First Lesson',
        fromLibrary: 'From Library',
        noLessons: 'No lessons yet',
        lessonsFor: 'Lessons: %{title}',
        backToCourses: 'Back to Courses',
        editContent: 'Edit Content',
        mandatory: 'Mandatory',
        minScore: 'Min. %{score}%',
        updateSuccess: 'Lesson successfully updated',
        createSuccess: 'Lesson successfully created',
        deleteSuccess: 'Lesson successfully deleted',
        saveError: 'Error saving lesson',
        deleteError: 'Error deleting lesson',
        confirmDelete: 'Do you really want to permanently delete this lesson?\n\nParticipant progress data will be automatically adjusted.',
        preview: 'Preview',
        learningContent: {
            label: 'Learning content (optional)',
            helper: 'This formatted text is shown above the quiz in the player.',
        },
        types: {
            video: 'Video',
            document: 'Document',
            infoText: 'Info Text',
            multipleChoice: 'Multiple Choice',
            fillInBlank: 'Fill in the Blank',
            freeText: 'Free Text',
            dragDrop: 'Drag & Drop',
            matching: 'Matching',
            sorting: 'Sorting',
            hotspot: 'Hotspot',
            timeline: 'Timeline',
            scorm: 'SCORM',
            h5p: 'H5P',
            xapi: 'xAPI',
        },
        form: {
            title: 'Title',
            type: 'Type',
            description: 'Description',
            estimatedDuration: 'Estimated Duration (minutes)',
            minScore: 'Minimum Score (%)',
            minScoreHelp: 'Percentage required to pass',
            isMandatory: 'Mandatory Lesson',
            active: 'Active',
            enablePeerReview: 'Enable Peer Review',
            peerReviewInfo: 'When enabled, participants must submit their answer and will receive feedback from other course participants.',
            minPeerReviews: 'Minimum Reviews',
            minPeerReviewsHelp: 'Number of reviews each submission must receive (1-10)',
            peerReviewCriteria: 'Review Criteria',
            criterionName: 'Criterion',
            criterionDescription: 'Description',
            maxPoints: 'Max Points',
            addCriterion: 'Add Criterion',
            aiTutor: 'AI Learning Assistant',
            aiTutorInherit: 'Inherit from Course',
            aiTutorEnabled: 'Enabled',
            aiTutorDisabled: 'Disabled',
        },
        peerReview: 'Peer Review',
    },
    courseRating: {
        title: 'Rate Course',
        editTitle: 'Edit Rating',
        rateButton: 'Rate',
        editButton: 'Edit Rating',
        yourRating: 'Your Rating',
        comment: 'Comment (optional)',
        commentPlaceholder: 'What did you like about this course or what could be improved?',
        submitSuccess: 'Rating successfully saved',
        updateSuccess: 'Rating successfully updated',
        deleteSuccess: 'Rating successfully deleted',
        noRatings: 'No ratings yet',
        ratings: '%{count} ratings',
        averageRating: 'Average',
        labels: {
            terrible: 'Terrible',
            poor: 'Poor',
            ok: 'OK',
            good: 'Good',
            excellent: 'Excellent',
        },
        errors: {
            ratingRequired: 'Please select a rating',
            saveFailed: 'Error saving rating',
            deleteFailed: 'Error deleting rating',
        },
    },
    prerequisites: {
        title: 'Prerequisites',
        noPrerequisites: 'No prerequisites',
        completed: 'Completed',
        required: 'Required',
        recommended: 'Recommended',
        hard: 'Required',
        soft: 'Recommended',
        clickToView: 'Click to view',
        status: {
            noRequired: 'No prerequisites',
            allMet: 'All met',
            allMetTooltip: 'You have completed all prerequisites',
            blocked: '%{count} required not met',
            blockedTooltip: 'You must first complete: %{courses}',
            recommended: '%{count} recommended',
            warningTooltip: 'Recommended courses: %{courses}',
        },
        warningDialog: {
            title: 'Recommended Prerequisites',
            message: 'The following courses are recommended for "%{course}" but you haven\'t completed them yet.',
            recommendedCourses: 'Recommended courses:',
            proceedAnyway: 'You can still proceed, but we recommend completing these courses first.',
            goBack: 'Go Back',
            proceedButton: 'Enroll Anyway',
        },
        blockDialog: {
            title: 'Prerequisites Not Met',
            message: 'You cannot enroll in "%{course}" because you haven\'t completed the required prerequisites.',
            requiredCourses: 'Required courses:',
            completeFirst: 'Please complete these courses first to enroll.',
        },
    },
    gamification: {
        achievements: 'My Achievements',
        badgesTitle: 'Badges',
        streakTitle: 'Learning Series',
        leaderboardTitle: 'Leaderboard',
        fullLeaderboard: 'Full Leaderboard',
        earned: 'Earned',
        available: 'Available',
        noBadgesYet: 'You haven\'t earned any badges yet. Complete courses to earn badges!',
        allBadgesEarned: 'Congratulations! You\'ve earned all available badges.',
        days: 'days',
        currentStreak: 'Current series',
        longestStreak: 'Longest series',
        rank: 'Rank',
        streakAtRisk: 'Your series is at risk! Learn something today.',
        streakAtRiskMessage: 'Learn today to keep your series!',
        streakTooltip: '%{days} day learning series',
        badgeEarned: 'Badge Earned!',
        awesome: 'Awesome!',
        congratulations: 'Congratulations!',
        leaderboard: {
            rank: 'Rank',
            user: 'User',
            courses: 'Courses',
            badges: 'Badges',
            streakDays: 'Series Days',
            byCourses: 'By Courses',
            byBadges: 'By Badges',
            byStreak: 'By Series',
            you: 'You',
            yourPosition: 'Your position',
        },
    },
    learningPaths: {
        title: 'Learning Paths',
        myPaths: 'My Learning Paths',
        explore: 'Explore Learning Paths',
        courses: 'Courses',
        search: 'Search learning paths...',
        difficulty: 'Difficulty',
        allDifficulties: 'All',
        beginner: 'Beginner',
        intermediate: 'Intermediate',
        advanced: 'Advanced',
        noPathsFound: 'No learning paths found',
        noEnrollments: 'No active learning paths',
        exploreDescription: 'Discover learning paths and start your journey',
        progress: 'Progress',
        yourProgress: 'Your progress',
        enroll: 'Enroll',
        enrollNow: 'Enroll Now',
        enrollSuccess: 'Successfully enrolled!',
        continue: 'Continue',
        viewCertificate: 'View',
        start: 'Start',
        completed: 'Completed',
        completedOn: 'Completed on',
        courseList: 'Course Overview',
        required: 'Required',
        optional: 'Optional',
        status: {
            enrolled: 'Enrolled',
            inProgress: 'In Progress',
            completed: 'Completed',
        },
    },
    common: {
        back: 'Back',
        viewAll: 'View all',
        cancel: 'Cancel',
        save: 'Save',
        saving: 'Saving...',
        delete: 'Delete',
    },
    recommendations: {
        title: 'Recommended for You',
        similarCourses: 'Similar Courses',
        enroll: 'Enroll',
        noRecommendations: 'No recommendations available',
        reasons: {
            sameCatalog: 'From your preferred catalog',
            nextDifficulty: 'Next difficulty level',
            sameDifficulty: 'Matching difficulty level',
            matchingTags: 'Similar topics',
            prerequisitesMet: 'Prerequisites met',
            popular: 'Popular with other learners',
            beginnerFriendly: 'Great for beginners',
        },
    },
    notifications: {
        title: 'Notifications',
        noNotifications: 'No notifications',
        markAllRead: 'Mark all read',
        justNow: 'Just now',
        minutesAgo: '%{count} min. ago',
        hoursAgo: '%{count} hr. ago',
        daysAgo: '%{count} days ago',
        types: {
            course_completed: 'Course completed',
            certificate_earned: 'Certificate earned',
            badge_earned: 'Badge earned',
            learning_path_completed: 'Learning path completed',
            streak_milestone: 'Series milestone',
            system: 'System message',
        },
    },
    emptyStates: {
        noCourses: {
            title: 'No courses found',
            description: 'There are no courses available yet. Check back later!',
            action: 'Browse course catalogs',
        },
        noBadges: {
            title: 'No badges yet',
            description: 'Complete courses and reach milestones to earn badges!',
        },
        noLearningPaths: {
            title: 'No learning paths',
            description: "You haven't enrolled in any learning paths yet.",
            action: 'Explore learning paths',
        },
        noRecommendations: {
            title: 'No recommendations',
            description: 'Complete more courses to get personalized recommendations.',
        },
        noEnrollments: {
            title: 'No courses yet',
            description: "You haven't enrolled in any courses yet. Explore our course catalog!",
            action: 'Discover courses',
        },
        noSearchResults: {
            title: 'No results',
            description: 'Try different search terms.',
            descriptionWithTerm: 'No results found for "%{term}". Try different search terms.',
        },
    },
    bookmarks: {
        title: 'My Bookmarks',
        add: 'Add bookmark',
        remove: 'Remove bookmark',
        noBookmarks: 'No bookmarks yet. Save interesting courses for later!',
        errorLoading: 'Error loading bookmarks',
        savedOn: 'Saved on',
        editNote: 'Edit note',
        noteLabel: 'Note',
        notePlaceholder: 'Why do you want to save this course?',
    },
    progress: {
        weeklyTitle: 'This Week',
        errorLoading: 'Error loading progress',
        lessonsCompleted: 'Lessons',
        coursesCompleted: 'Courses',
        activeDays: 'Active Days',
        dailyActivity: 'Daily Activity',
        lessons: 'lessons',
        overallProgress: 'Overall Progress',
        coursesLabel: 'courses',
        inProgress: 'In Progress',
        complete: 'complete',
        days: {
            mon: 'Mon',
            tue: 'Tue',
            wed: 'Wed',
            thu: 'Thu',
            fri: 'Fri',
            sat: 'Sat',
            sun: 'Sun',
        },
    },
    notes: {
        notes: 'Notes',
        add: 'Add',
        addNote: 'Add Note',
        newNote: 'New Note',
        editNote: 'Edit Note',
        edit: 'Edit',
        delete: 'Delete',
        title: 'Title',
        titlePlaceholder: 'Optional title...',
        content: 'Content',
        contentPlaceholder: 'Write your note here...',
        color: 'Color',
        privateNote: 'Private Note',
        private: 'Private',
        public: 'Public',
        untitled: 'Untitled',
        noNotes: 'No notes yet',
        noLessonNotes: 'No notes for this lesson',
        createFirst: 'Create your first note',
        createFirstNote: 'Create your first note in a course',
        currentLesson: 'Current Lesson',
        otherCourseNotes: 'Notes from other lessons',
        errorLoading: 'Error loading notes',
        loadError: 'Error loading notes',
        deleteConfirmTitle: 'Delete Note?',
        deleteConfirmMessage: 'Are you sure you want to delete this note?',
        // Overview page
        myNotes: 'My Notes',
        overviewDescription: 'All your notes from all courses in one place.',
        search: 'Search notes...',
        sort: 'Sort',
        filter: 'Filter',
        sortByDate: 'By Date',
        sortByTitle: 'By Title',
        sortByCourse: 'By Course',
        filterAll: 'All Notes',
        filterWithLesson: 'With Lesson',
        filterCourseOnly: 'Course Notes Only',
        totalNotes: '%{count} notes',
        totalCourses: '%{count} courses',
        notesCount: '%{count} notes',
        notesLabel: 'Notes',
        coursesLabel: 'Courses',
        noSearchResults: 'No notes found',
        tryDifferentSearch: 'Try a different search term',
        goToCourse: 'Go to Course',
        courseUnavailable: 'Course no longer available',
        exportPdf: 'Download as PDF',
        exportPdfShort: 'PDF',
    },
    search: {
        title: 'Search',
        placeholder: 'Search courses, wiki, learning paths...',
        resultsFor: 'Results for "%{query}"',
        results: 'results',
        noResults: 'No results found',
        tryDifferentTerms: 'Try different search terms',
        enterQuery: 'Enter a search term',
        errorSearch: 'Error during search',
        filters: 'Filters',
        contentType: 'Content Type',
        difficultyLabel: 'Difficulty',
        allDifficulties: 'All Difficulties',
        fromCourse: 'From course',
        types: {
            course: 'Course',
            lesson: 'Lesson',
            wiki: 'Wiki Article',
            learningPath: 'Learning Path',
        },
        difficulty: {
            beginner: 'Beginner',
            intermediate: 'Intermediate',
            advanced: 'Advanced',
        },
    },
    export: {
        button: 'Export',
        dialog: {
            title: 'Export Data',
        },
        forCourse: 'For Course',
        general: 'General Exports',
        success: 'Export downloaded successfully!',
        'learning-history': {
            label: 'Learning History',
            description: 'Complete overview of all courses and progress',
        },
        transcript: {
            label: 'Course Transcript',
            description: 'Detailed report about this course',
        },
        notes: {
            label: 'Notes',
            description: 'Your personal notes as PDF',
        },
        'progress-report': {
            label: 'Progress Report',
            description: 'CSV export with detailed progress data',
        },
    },
    analytics: {
        title: 'My Learning Statistics',
        errorLoading: 'Error loading analytics',
        totalCourses: 'Total Courses',
        completedCourses: 'Completed',
        inProgress: 'in progress',
        learningTime: 'Learning Time',
        achievements: 'Achievements',
        completionRate: 'Completion Rate',
        lessonsCompleted: 'Lessons Completed',
        learningTimePerDay: 'Learning Time per Day',
        recentCompletions: 'Recent Completions',
        noCompletions: 'No completions yet',
        progressSummary: 'Progress Summary',
        avgProgress: 'Average Progress',
        avgScore: 'Average Score',
        myCourses: 'My Courses',
        noCourses: 'No courses available',
        enrolled: 'Enrolled',
        time: 'Time',
        activityOverview: 'Activity Overview',
        enrollmentTrend: 'Enrollments',
        completionTrend: 'Course Completions',
        inLast: 'In the last',
        days: 'days',
        noCourseData: 'No course data available',
        course: 'Course',
        participants: 'Participants',
        period: {
            week: '7 Days',
            month: '30 Days',
            quarter: '90 Days',
        },
        tabs: {
            overview: 'Overview',
            courses: 'Courses',
            activity: 'Activity',
        },
        status: {
            completed: 'Completed',
            inProgress: 'In Progress',
            enrolled: 'Enrolled',
        },
        instructor: {
            title: 'Instructor Dashboard',
            subtitle: 'Overview of your course performance',
            errorLoading: 'Error loading instructor statistics',
            noCourses: 'You have not created any courses yet',
            createCourse: 'Create a course to see statistics',
            myCourses: 'My Courses',
            participants: 'Participants',
            enrollments: 'Enrollments',
            completions: 'Completions',
            completionRate: 'Completion Rate',
            avgProgress: 'Avg. Progress',
            avgProgressShort: 'Avg. Progress',
            avgScore: 'Avg. Score',
            courseOverview: 'Course Overview',
            course: 'Course',
            enrolled: 'Enrolled',
            completed: 'Completed',
            lessonDetails: 'Lesson Details',
            selectCourse: 'Select a course from the table',
            courseStatsError: 'Course statistics could not be loaded',
            lesson: 'Lesson',
            attempts: 'Attempts',
            lessonCompletions: 'Completions',
            avgTime: 'Avg. Time',
        },
    },
    privacy: {
        title: 'Privacy',
        subtitle: 'Download a full copy of your data (Art. 15/20 GDPR) or delete your account (Art. 17 GDPR).',
        exportButton: 'Download my data (PDF)',
        exportButtonJson: 'As JSON for other providers',
        exportSuccess: 'Your data export has been downloaded.',
        exportError: 'Export failed. Please try again.',
        deleteButton: 'Delete account',
        deleteTitle: 'Request deletion of your account?',
        deleteWarning: 'Your company administrator receives your request and decides within one month. Once approved, your account is anonymised and permanently deleted after the retention period. If nobody decides by then, it is deleted automatically. Until a decision is made you can keep signing in and withdraw the request.',
        deleteConfirmButton: 'Request deletion',
        deleteConfirmLabel: 'Type "LÖSCHEN" to confirm',
        deleteConfirmWord: 'LÖSCHEN',
        deleteSuccess: 'Your deletion request has been received. Your company administrator will decide by %{dueAt}.',
        pendingTitle: 'Deletion requested',
        pendingText: 'On %{requestedAt} you requested to delete your account. Your company administrator will decide by %{dueAt}.',
        withdrawButton: 'Withdraw request',
        withdrawSuccess: 'Your deletion request has been withdrawn.',
        cancel: 'Cancel',
    },
    aiGrading: {
        disclaimer: 'Your answer will be pre-graded by an AI system. Please do not enter sensitive personal information. You always have the right to a review by your trainer.',
        attribution: 'AI-assisted grading — contact your trainer if you disagree.',
        model: 'Model',
        reviewPending: 'This grading will be reviewed by your trainer and only counts after approval.',
        reviewPendingLesson: 'Your answers have been submitted. The AI pre-grading will be reviewed by your trainer — the lesson completes automatically after approval.',
    },
    aiReview: {
        title: 'Review AI gradings',
        subtitle: 'AI pre-graded free-text answers of your learners. For courses with mandatory review, the grading only counts after your approval.',
        status: 'Status',
        all: 'All',
        minScore: 'Score from',
        maxScore: 'Score to',
        course: 'Course / lesson',
        answer: 'Answer',
        score: 'AI score',
        statusCol: 'Status',
        date: 'Submitted',
        actions: 'Actions',
        approve: 'Approve',
        override: 'Override',
        overrideTitle: 'Override grading',
        overrideHint: 'AI suggestion',
        newScore: 'New score',
        newFeedback: 'Feedback for the learner',
        originalAi: 'AI original',
        cancel: 'Cancel',
        save: 'Save',
        approved: 'Grading approved.',
        approvedCompleted: 'Approved — lesson has been completed.',
        overridden: 'Grading overridden.',
        empty: 'No AI gradings for the current filter.',
    },
    tutor: {
        title: 'AI Learning Assistant',
        aiLabel: 'AI',
        disclaimerTitle: 'You are chatting with an AI',
        disclaimerBody: 'The learning assistant is an AI system. Answers can be inaccurate or incomplete — do not rely on it alone for important questions and ask your trainer when in doubt. Your conversations are private, processed on our own servers, and you can delete them at any time. Please do not enter sensitive personal information.',
        disclaimerAccept: 'Got it',
        newConversation: 'New Conversation',
        history: 'History',
        noConversations: 'No previous conversations',
        welcomeTitle: 'Hello! I am your learning assistant.',
        welcomeWithLesson: 'Ask me questions about the lesson "%{lesson}"',
        welcomeGeneral: 'Ask me a question about the course content.',
        inputPlaceholder: 'Ask a question...',
        inputWithLesson: 'Question about "%{lesson}"...',
        quickHelpLabel: 'Quick Help',
        quickHelp: {
            explain: 'Simplify',
            explainTooltip: 'Explain this content more simply',
            example: 'Example',
            exampleTooltip: 'Show me an example',
            quiz: 'Test Me',
            quizTooltip: 'Ask me a question to test my understanding',
            summary: 'Summary',
            summaryTooltip: 'Summarize the content',
        },
        error: 'Error with request',
        loadError: 'Error loading',
    },
    learningGroups: {
        title: 'Learning Groups',
        myGroups: 'My Learning Groups',
        explore: 'Explore Learning Groups',
        createGroup: 'Create Learning Group',
        noGroups: 'No learning groups found',
        noMyGroups: 'You have not joined any learning groups yet',
        loading: 'Loading learning groups...',
        members: '%{count} members',
        maxMembers: 'Max. %{count} members',
        course: 'Course',
        public: 'Public',
        private: 'Invite only',
        join: 'Join',
        leave: 'Leave group',
        viewGroup: 'View Group',
        createdBy: 'Created by %{name}',
        joinSuccess: 'Successfully joined!',
        leaveSuccess: 'Left group',
        errorJoining: 'Error joining group',
        errorLeaving: 'Error leaving group',
        createDialog: {
            title: 'Create New Learning Group',
            name: 'Group Name',
            namePlaceholder: 'e.g. JavaScript Beginners',
            description: 'Description',
            descriptionPlaceholder: 'Describe what the group is about...',
            course: 'Course (optional)',
            selectCourse: 'Select course',
            noCourse: 'No course',
            maxMembers: 'Max. Members',
            maxMembersHelp: 'Leave empty for unlimited',
            isPublic: 'Public Group',
            isPublicHelp: 'Public groups can be joined by anyone',
        },
        detail: {
            members: 'Members',
            chat: 'Group Chat',
            admin: 'Admin',
            member: 'Member',
            noMessages: 'No messages yet. Start the conversation!',
            typePlaceholder: 'Type a message...',
            send: 'Send',
            you: 'You',
            errorLoading: 'Error loading group',
            errorSending: 'Error sending message',
        },
        tabs: {
            myGroups: 'My Learning Groups',
            explore: 'Explore',
        },
    },
    peerReview: {
        title: 'Peer Reviews',
        tabs: {
            toReview: 'To Review',
            mySubmissions: 'My Submissions (%{count})',
        },
        noPendingReviews: 'No pending reviews',
        noSubmissions: 'No submissions yet',
        status: {
            pending: 'Pending',
            inReview: 'In Review',
            completed: 'Completed',
        },
        assignedOn: 'Assigned on %{date}',
        submittedOn: 'Submitted on %{date}',
        reviewsReceived: '%{count} reviews',
        review: 'Review',
        viewFeedback: 'View Feedback',
        notFound: 'Assignment not found',
        submitTitle: 'Submit for Peer Review',
        submitDescription: 'Submit your work for the lesson "%{lesson}". Other participants will review your submission.',
        submissionLabel: 'Your Submission',
        submissionPlaceholder: 'Describe your solution or paste your text here...',
        submit: 'Submit',
        submitSuccess: 'Your submission has been submitted successfully and will be reviewed by other participants.',
        reviewTitle: 'Peer Review: %{lesson}',
        submissionToReview: 'Submission to Review',
        criteria: 'Review Criteria',
        yourReview: 'Your Review',
        ratingLabel: 'Overall Rating',
        feedbackLabel: 'Your Feedback',
        feedbackPlaceholder: 'Provide constructive feedback on the submission. What was good? What could be improved?',
        submitReview: 'Submit Review',
        resultTitle: 'Feedback for: %{lesson}',
        yourSubmission: 'Your Submission',
        averageRating: 'Average Rating',
        reviewCount: '%{count} reviews',
        receivedFeedback: 'Received Feedback',
        noFeedbackYet: 'No feedback received yet. Your submission is still being reviewed.',
        reviewer: 'Reviewer %{number}',
        reviewedOn: 'Reviewed on %{date}',
        attachFile: 'Attach file',
        fileHint: 'Optional: PDF, Word, Text, Images or ZIP (max. 10MB)',
        downloadAttachment: 'Download attachment',
        errors: {
            submissionRequired: 'Please enter your submission',
            ratingRequired: 'Please provide a rating',
            feedbackRequired: 'Please provide feedback',
            fileTooLarge: 'File too large (max. 10MB)',
        },
    },
    faq: {
        title: 'Help & FAQ',
        subtitle: 'Find answers to frequently asked questions',
        searchPlaceholder: 'Search FAQ...',
        allCategories: 'All',
        noResults: 'No FAQ entries found for your search.',
        noArticles: 'No FAQ entries available yet.',
        loadError: 'Error loading FAQ',
        contentError: 'Content could not be loaded.',
        noContent: 'No content available.',
        contactSupport: 'Question not found? Contact our support.',
    },
    products: {
        title: 'Products',
        searchPlaceholder: 'Search products...',
        filterType: 'Type',
        filterVisibility: 'Visibility',
        allTypes: 'All types',
        allVisibility: 'All',
        loadError: 'Error loading products',
        noProducts: 'No products available.',
        noSearchResults: 'No products found for your search.',
        featured: 'Featured',
        inactive: 'Inactive',
        noPrice: 'No price set',
        types: {
            course: 'Course',
            catalog: 'Catalog',
            bundle: 'Bundle',
            libraryItem: 'Library Item',
        },
        visibility: {
            public: 'Public',
            private: 'Private',
            unlisted: 'Unlisted',
        },
        pricing: {
            free: 'Free',
            oneTime: 'One-time payment',
            subscription: 'Subscription',
            perMonth: 'per month',
            perYear: 'per year',
        },
        actions: {
            view: 'View',
            edit: 'Edit',
            delete: 'Delete',
            addToCart: 'Add to Cart',
            enroll: 'Enroll Now',
        },
    },
    library: {
        title: 'Content Library',
        tabs: {
            myLibrary: 'My Library',
            operatorLibrary: 'Platform Library',
            company: 'My Library',
            operator: 'Platform Library',
        },
        search: 'Search library...',
        selectDialog: {
            titleCourse: 'Insert Course from Library',
            titleLesson: 'Insert Lesson from Library',
        },
        types: {
            course: 'Course',
            lesson: 'Lesson',
        },
        access: {
            copyAllowed: 'Copy allowed',
            referenceOnly: 'Reference only',
        },
        operatorContent: 'Platform content',
        usageCount: 'Used %{count} times',
        version: 'Version %{version}',
        searchPlaceholder: 'Search library...',
        filterType: 'Type',
        allTypes: 'All types',
        refresh: 'Refresh',
        loadError: 'Error loading library',
        noSearchResults: 'No results found for your search.',
        noItems: 'No items in the library yet.',
        insertSuccess: '"%{title}" successfully inserted',
        insertError: 'Error inserting from library',
        confirmDelete: 'Do you really want to delete "%{title}" from the library?',
        deleteSuccess: 'Successfully deleted from library',
        deleteError: 'Error deleting',
        actions: {
            insert: 'Insert',
            edit: 'Edit',
            delete: 'Delete',
            share: 'Share',
        },
        saveDialog: {
            title: 'Save to Library',
            titleLabel: 'Title',
            descriptionLabel: 'Description',
            tagsLabel: 'Tags',
            tagsPlaceholder: 'Enter a tag...',
            tagsHelp: 'Press Enter to add a tag',
            operatorContent: 'Save as platform content',
            operatorContentHint: 'Platform content can be shared with tenants and is only visible to operators.',
            save: 'Save to Library',
            titleRequired: 'Title is required',
            success: 'Successfully saved to library',
            error: 'Error saving to library',
        },
        insertDialog: {
            title: 'Insert from Library',
            description: 'Choose how to insert the content:',
            copyNotAllowed: 'Only reference mode is available for this content.',
            copyOption: 'Create Copy',
            copyDescription: 'Creates an independent copy that you can edit freely.',
            referenceOption: 'Create Reference',
            referenceDescription: 'Stays linked to the original. You will be notified of updates.',
            confirm: 'Insert',
            courseCreated: 'Course "%{title}" successfully %{mode}',
            lessonCreated: 'Lesson "%{title}" successfully %{mode}',
            asCopy: 'created as copy',
            asReference: 'created as reference',
        },
        sharing: {
            title: 'Share Content',
            description: 'Select the tenants to share this content with.',
            noCompanies: 'No tenants available.',
            loadError: 'Error loading tenants.',
            saveSuccess: 'Sharing settings saved successfully.',
            saveError: 'Error saving sharing settings.',
            revokeSuccess: 'Access revoked successfully.',
            revokeError: 'Error revoking access.',
            revoke: 'Revoke access',
            accessType: 'Access type',
            readonly: 'Reference only (read-only)',
            copyAllowed: 'Copy allowed',
            expiresAt: 'Expiration date',
            expiresAtHelp: 'Leave empty for unlimited access',
        },
        updates: {
            title: 'Available Updates',
            description: '%{count} content item(s) have updates available from the library.',
            checking: 'Checking for updates...',
            apply: 'Apply Update',
            applySuccess: 'Update applied successfully.',
            applyError: 'Error applying update.',
            versionChange: 'Version %{from} → %{to}',
            noUpdates: 'All content is up to date.',
        },
    },
    cart: {
        title: 'Shopping Cart',
        empty: {
            title: 'Your cart is empty',
            description: 'Discover our products and add them to your cart.',
        },
        unknownProduct: 'Unknown product',
        subtotal: 'Subtotal',
        discount: 'Discount',
        tax: 'Tax',
        total: 'Total',
        actions: {
            checkout: 'Checkout',
            continueShopping: 'Continue Shopping',
            clear: 'Clear',
            remove: 'Remove',
        },
        messages: {
            itemAdded: 'Product added to cart',
            itemRemoved: 'Product removed from cart',
            cartCleared: 'Cart cleared',
            addError: 'Error adding to cart',
            removeError: 'Error removing from cart',
            updateError: 'Error updating cart',
            clearError: 'Error clearing cart',
        },
    },
    orders: {
        title: 'My Orders',
        loading: 'Loading orders...',
        noOrders: 'No orders found.',
        orderNumber: 'Order Number',
        orderDate: 'Order Date',
        items: 'Items',
        total: 'Total',
        status: {
            pending: 'Pending',
            paid: 'Paid',
            completed: 'Completed',
            cancelled: 'Cancelled',
            refunded: 'Refunded',
        },
        paymentStatus: {
            pending: 'Pending',
            processing: 'Processing',
            completed: 'Completed',
            failed: 'Failed',
        },
        actions: {
            view: 'View Details',
            cancel: 'Cancel',
            download: 'Download Invoice',
        },
        detail: {
            title: 'Order Details',
            customerInfo: 'Customer Information',
            billingAddress: 'Billing Address',
            orderItems: 'Order Items',
            paymentInfo: 'Payment Information',
        },
        messages: {
            cancelSuccess: 'Order cancelled successfully',
            cancelError: 'Error cancelling order',
        },
    },
    checkout: {
        title: 'Checkout',
        steps: {
            review: 'Review',
            customer: 'Customer',
            payment: 'Payment',
            confirmation: 'Confirmation',
        },
        customerForm: {
            title: 'Your Details',
            email: 'Email Address',
            name: 'Full Name',
            billingAddress: 'Billing Address',
            street: 'Street and Number',
            city: 'City',
            postalCode: 'Postal Code',
            country: 'Country',
        },
        summary: {
            title: 'Order Summary',
            subtotal: 'Subtotal',
            discount: 'Discount',
            tax: 'Tax',
            total: 'Total',
        },
        payment: {
            title: 'Payment Method',
            paypal: 'Pay with PayPal',
            processing: 'Processing payment...',
        },
        confirmation: {
            title: 'Order Confirmed!',
            thankYou: 'Thank you for your order!',
            orderNumber: 'Your order number: %{orderNumber}',
            emailSent: 'A confirmation email has been sent to %{email}.',
            viewOrders: 'My Orders',
            continueShopping: 'Continue Shopping',
        },
        errors: {
            validationFailed: 'Please fill in all required fields.',
            paymentFailed: 'Payment failed. Please try again.',
            orderCreationFailed: 'Error creating order.',
        },
    },
};
